import { isCorrectDiscussionResponse } from '../../guards/isCorrectAiResponse';

/** Parses assistant discussion JSON content into the `answer` string, or `''` if invalid. */
export const getDiscussionAnswer = (content: string): string => {
  try {
    const parsedContent = JSON.parse(content || '');
    if (!isCorrectDiscussionResponse(parsedContent)) return '';

    return parsedContent.answer;
  } catch {
    return '';
  }
};
